export const createUiBuilderPage = `
  mutation MyMutation(
    $hotelId: String!,
    $name: String!,
    $lang: String

    ) {
    createUiBuilderPage(
      input: {
        hotelId: $hotelId, 
        name: $name
      lang: $lang
      }
    ){
      id
    }
  }
`;

export const updateUiBuilderPage = `
  mutation MyMutation(
    $hotelId: String!,
    $name: String!,
    $id: String!
    $lang: String
  ) {
    updateUiBuilderPage(
      input: {
        hotelId: $hotelId, 
        id: $id, 
        name: $name
      lang: $lang
      }
    ){
      hotelId
      id
 }
}
`;

export const deleteUIBuilderPage = `
  mutation MyMutation(
    $hotelId: String!
    $id: String!
    $lang: String
  ) {
  deletePage(
    input: {
      hotelId: $hotelId
      id: $id
      lang: $lang
    }) {
    message
    status
    }
  }`;

export const duplicateUIBuilderPage = `
  mutation MyMutation(
  $hotelId: String!
  $id: String!
  $name: String!
  $lang: String
  ) {
    duplicatePage(
      input: {
        hotelId: $hotelId
        id: $id
        name: $name
      lang: $lang
    }) {
      createdBy
    hotelId
    id
    name
    uiConfiguration
    status
    }
  }
`;

export const updateUiBuilderPageConfigs = `
  mutation MyMutation(
    $hotelId: String!,
    $uiConfiguration: String!,
    $id: String!
  $lang: String
  ) {
    updateUiBuilderPageConfigs(
      input: {
        hotelId: $hotelId, 
        id: $id, 
        uiConfiguration: $uiConfiguration
      lang: $lang
      }
    ){
      id
 }
}
`;

export const publishPage = `
mutation MyMutation(
  $hotelId: String!,
  $id: String!
  $lang: String
) {
  publishPage(
    input: {
      hotelId: $hotelId
      id: $id
      lang: $lang
    }
  ){
      status
      publishedAt
    }
}
`;

export const createUiBuilderMenu = `
mutation MyMutation(
  $hotelId: String!
  $name: String!
  $pageId: String!
  $lang: String
) {
  createUiBuilderMenu(
    input: {
      hotelId: $hotelId
      name: $name 
      pageId: $pageId
      lang: $lang
    }) {
    createdAt
    createdBy
    hotelId
    menuList {
      id
      name
      pageId
    }
    updatedAt
    updatedBy
    version
  }
}
`;

export const updateUiBuilderMenu = `
mutation MyMutation(
  $id: String!
  $hotelId: String!
  $name: String!
  $pageId: String!
  $lang: String
) {
  updateUiBuilderMenu(
    input: {
      hotelId: $hotelId
      id: $id
      name: $name
      pageId: $pageId
      lang: $lang
    }) {
    createdAt
    createdBy
    hotelId
    menuList {
      id
      name
      pageId
    }
    updatedBy
    updatedAt
    version
  }
}`;

export const deleteUiBuilderMenuItem = `
mutation MyMutation(
  $id: String!
  $hotelId: String!
  $lang: String
) {
  deleteUiBuilderMenuItem(input:{
    id: $id
    hotelId: $hotelId
    lang: $lang
  }) {
    message
    status
  }
}`;

export const reOrderUiBuilderMenuItems = `
mutation MyMutation(
  $hotelId:String!
  $menuList:[UiBuilderMenuItemInput]!
  $lang: String
) {
  reOrderUiBuilderMenuItems(
      input: {
        hotelId: $hotelId
        menuList: $menuList
        lang: $lang
      }
    ) {
      version
    }
  }`;

export const createUiBuilderHamburgerMenu = `
mutation MyMutation(
  $hotelId: String!
  $name: String!
  $pageId: [String]
  $category : String!
  $redirectOptions : String!
  $externalLink : String!
  $flow: String
  $isActive: Boolean!
  $menuIconUrl:String!
  $lang: String
) {
  createUiBuilderHamburgerMenu (
    input: {
      hotelId: $hotelId
      name: $name 
      pages: $pageId
      category : $category
      redirectOptions : $redirectOptions
      externalLink : $externalLink
      flow: $flow
      isActive: $isActive
      menuIconUrl:$menuIconUrl
      lang: $lang
    }) {
    id
  }
}
`;

export const updateUiBuilderHamburgerMenu = `
mutation MyMutation(
  $id: String!
  $hotelId: String!
  $name: String!
  $pageId: [String]
  $category : String!
  $redirectOptions : String!
  $externalLink : String!
  $flow: String
  $isActive: Boolean!
  $menuIconUrl:String!
  $lang: String
) {
  updateUiBuilderHamburgerMenu(
    input: {
      id: $id
      hotelId: $hotelId
      name: $name 
      pages: $pageId
      category : $category
      redirectOptions : $redirectOptions
      externalLink : $externalLink
      flow: $flow 
      isActive: $isActive
      menuIconUrl:$menuIconUrl
      lang: $lang
    }) {
    id
  }
}
`;

export const deleteUiBuilderHamburgerMenuItem = `
mutation MyMutation(
  $id: String!
  $hotelId: String!
  $lang: String
) {
  deleteUiBuilderHamburgerMenuItem(input:{
    id: $id
    hotelId: $hotelId
    lang: $lang
  }) {
    message
    status
  }
}`;

export const updateUiBuilderHamburgerMenuState = `
mutation MyMutation(
  $id: String!
  $hotelId: String!
  $status: Boolean!
  $lang: String
) {
  updateUiBuilderHamburgerMenuState(
    input: {
      id: $id
      hotelId: $hotelId
      status: $status 
      lang: $lang
    }) {
    message
    status
  }
}
`;
